import { createEntityAdapter } from '@reduxjs/toolkit';

import type { WallPreviewSampleRoom, WallPreviewUserRoom } from './wall_preview_rooms.types';

const wallPreviewsAdapter = createEntityAdapter<WallPreviewUserRoom | WallPreviewSampleRoom>({
  // Sort user rooms ahead of sample rooms
  // Sort user rooms by updated_at
  // Sort sample rooms by the order they appear in the static array
  sortComparer(a, b) {
    const bothSample = a.type === 'sample' && b.type === 'sample';
    const bothUser = a.type === 'user' && b.type === 'user';

    if (bothUser) {
      const dateA = new Date(a.updated_at);
      const dateB = new Date(b.updated_at);
      return dateA > dateB ? -1 : 1;
    }

    if (bothSample) {
      const posA = a.id.split('sample')[1];
      const posB = b.id.split('sample')[1];
      return parseInt(posA) - parseInt(posB);
    }

    return a.type === 'user' ? -1 : 1;
  },
});

export default wallPreviewsAdapter;
